import React, { FunctionComponent, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthState } from '../reducers/types';
import GenericIcons from './generics/GenericIcons';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import Logout from './auth/Logout';
import VdrWordmark from './brand/VdrWordmark';
import '../css/PrivateNavbar.css';

const PrivateNavBar: FunctionComponent<{ auth: AuthState }> = ({ auth }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();

  const userInitials = useMemo(() => {
    if (auth.user) {
      const initials = (
        (auth.user?.userAccountFirstname || '').trim().split(' ')[0] + // Primer nombre + Primer Apellido
        (auth.user?.userAccountLastname || '').trim().split(' ')[0]
      )
        .split(' ')
        .filter((word) => word.length > 0)
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join('');

      return initials || 'NN';
    }
    return 'NN';
  }, [auth.user]);
  return (
    <div className='private-navbar-container'>
      <div className='private-navbar-logo-container'>
        <button type='button' className='vdr-app-brand' onClick={() => navigate('/public')}>
          <VdrWordmark onDark size='md' />
        </button>
      </div>

      <div className='private-navbar-avatar-container'>
        {/* Nombre y rol del usuario: solo presentación, mismos datos que ya usa el menú */}
        <div className='vdr-app-user'>
          <span className='vdr-app-user-name'>
            {(auth.user?.userAccountFirstname || '').trim().split(' ')[0]}{' '}
            {(auth.user?.userAccountLastname || '').trim().split(' ')[0]}
          </span>
          {auth.user?.userTypeName ? (
            <span className='vdr-app-user-role'>{auth.user.userTypeName}</span>
          ) : null}
        </div>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            width: 'auto',
            height: '100%'
          }}>
          <IconButton
            onClick={handleClick}
            size='small'
            className='vdr-app-avatar-button'
            sx={{ height: '100%', padding: 0, aspectRatio: '1/1', borderRadius: 0 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}>
            <Avatar className='private-navbar-avatar' variant='square'>
              {userInitials}
            </Avatar>
          </IconButton>
        </Box>
        <Menu
          anchorEl={anchorEl}
          id='account-menu'
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                mt: 1,
                minWidth: 232,
                borderRadius: 0,
                border: '1px solid var(--vdr-line)',
                borderTop: '3px solid var(--vdr-cyan)',
                boxShadow: 'var(--vdr-shadow-overlay)',
                '& .MuiList-root': { padding: '0 0 6px' }
              }
            }
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
          {/* Ítems directos del menú de MUI: se recorren con flechas y se activan con Enter. */}
          <ListSubheader
            disableSticky
            className='private-navbar-avatar-menu-item private-navbar-avatar-title-item'>
            👋 Hola {(auth.user?.userAccountFirstname || '').trim().split(' ')[0]}
          </ListSubheader>
          <MenuItem
            className='private-navbar-avatar-menu-item'
            onClick={() => navigate('/private/estudios')}>
            <GenericIcons icon='listIcon' imageStyle={{ height: '100%' }} />
            Mis estudios
          </MenuItem>
          <Logout
            className='private-navbar-avatar-menu-item'
            icon='arrowRightIcon'
            textLogout='Cerrar sesión'
          />
        </Menu>
      </div>
    </div>
  );
};

export default PrivateNavBar;
